<div class="header">
    <div class="header-content">
      <nav class="navbar navbar-expand">
        <div class="collapse navbar-collapse justify-content-between">
          <div class="header-left">
            
          </div>
          <ul class="navbar-nav header-right">
            <!-- DB Query Agent launcher -->
            <li *ngIf="canUseAgent" class="nav-item">
              <a class="nav-link c-pointer" href="javascript:void(0);" (click)="agentChat.toggle()" title="Ask the DB Query Agent" aria-label="Open DB Query Agent">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7117 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.6056 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </a>
            </li>

            <li class="nav-item dropdown notification_dropdown display">
              <a class="nav-link " href="javascript:void(0);" data-bs-toggle="dropdown">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M20.8067 7.62358L20.1842 6.54349C19.6577 5.62957 18.4907 5.31429 17.5755 5.83869V5.83869C17.1399 6.09531 16.6201 6.16812 16.1307 6.04106C15.6413 5.91399 15.2226 5.59749 14.9668 5.16134C14.8023 4.88412 14.7139 4.56836 14.7105 4.24601V4.24601C14.7254 3.72919 14.5304 3.22837 14.17 2.85764C13.8096 2.48691 13.3145 2.27783 12.7975 2.27805H11.5435C11.037 2.27804 10.5513 2.47988 10.194 2.83891C9.83669 3.19795 9.63717 3.68456 9.63961 4.19109V4.19109C9.6246 5.23689 8.77248 6.07678 7.72657 6.07667C7.40421 6.07332 7.08846 5.98491 6.81123 5.82038V5.82038C5.89606 5.29598 4.72911 5.61126 4.20254 6.52519L3.53435 7.62358C3.00841 8.53636 3.3194 9.70258 4.23 10.2323V10.2323C4.8219 10.574 5.18653 11.2056 5.18653 11.889C5.18653 12.5725 4.8219 13.204 4.23 13.5458V13.5458C3.32056 14.0719 3.00923 15.2353 3.53435 16.1453V16.1453L4.16593 17.2346C4.41265 17.6798 4.8266 18.0083 5.31619 18.1474C5.80578 18.2866 6.33064 18.2249 6.77462 17.976V17.976C7.21108 17.7213 7.73119 17.6515 8.21934 17.7822C8.70749 17.9128 9.12324 18.233 9.37416 18.6716C9.5387 18.9489 9.62711 19.2646 9.63046 19.587V19.587C9.63046 20.6435 10.487 21.5 11.5435 21.5H12.7975C13.8505 21.5 14.7055 20.6491 14.7105 19.5961V19.5961C14.7081 19.088 14.9089 18.6 15.2682 18.2407C15.6275 17.8814 16.1155 17.6806 16.6236 17.6831C16.9452 17.6917 17.2596 17.7797 17.5389 17.9394V17.9394C18.4517 18.4653 19.6179 18.1543 20.1476 17.2437V17.2437L20.8067 16.1453C21.0618 15.7075 21.1318 15.186 21.0012 14.6963C20.8706 14.2067 20.5502 13.7893 20.111 13.5366V13.5366C19.6718 13.2839 19.3514 12.8665 19.2208 12.3769C19.0902 11.8873 19.1603 11.3658 19.4154 10.9279C19.5812 10.6383 19.8214 10.3982 20.111 10.2323V10.2323C21.0161 9.70286 21.3264 8.54346 20.8067 7.63274V7.63274V7.62358Z" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                  <circle cx="12.1751" cy="11.889" r="2.63616" stroke="white" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </a>
              <div class="dropdown-menu dropdown-menu-end">
                <div id="DZ_W_TimeLine02" class="widget-timeline dz-scroll style-1 p-3 height370">
                  <ul class="timeline">
                    <li>
                      <div class="timeline-badge primary"></div>
                      <a class="timeline-panel text-muted" href="javascript:void(0);">
                        <span>10 minutes ago</span>
                        <h6 class="mb-0">Youtube, a video-sharing website, goes live <strong class="text-primary">$500</strong>. </h6>
                      </a>
                    </li>
                    <li>
                      <div class="timeline-badge info"></div>
                      <a class="timeline-panel text-muted" href="javascript:void(0);">
                        <span>20 minutes ago</span>
                        <h6 class="mb-0">New order placed <strong class="text-info">#XF-2356.</strong>
                        </h6>
                        <p class="mb-0">Quisque a consequat ante Sit amet magna at volutapt...</p>
                      </a>
                    </li>
                    <li>
                      <div class="timeline-badge danger"></div>
                      <a class="timeline-panel text-muted" href="javascript:void(0);">
                        <span>30 minutes ago</span>
                        <h6 class="mb-0">john just buy your product <strong class="text-warning">Sell $250</strong>
                        </h6>
                      </a>
                    </li>
                    <li>
                      <div class="timeline-badge success"></div>
                      <a class="timeline-panel text-muted" href="javascript:void(0);">
                        <span>15 minutes ago</span>
                        <h6 class="mb-0">StumbleUpon is acquired by eBay. </h6>
                      </a>
                    </li>
                    <li>
                      <div class="timeline-badge warning"></div>
                      <a class="timeline-panel text-muted" href="javascript:void(0);">
                        <span>20 minutes ago</span>
                        <h6 class="mb-0">Mashable, a news website and blog, goes live.</h6>
                      </a>
                    </li>
                    <li>
                      <div class="timeline-badge dark"></div>
                      <a class="timeline-panel text-muted" href="javascript:void(0);">
                        <span>20 minutes ago</span>
                        <h6 class="mb-0">Mashable, a news website and blog, goes live.</h6>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
            <li class="nav-item dropdown notification_dropdown display">
              <a class="nav-link" href="javascript:void(0);" role="button" data-bs-toggle="dropdown">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 8C18 6.4087 17.3679 4.88258 16.2426 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.88258 2.63214 7.75736 3.75736C6.63214 4.88258 6 6.4087 6 8C6 15 3 17 3 17H21C21 17 18 15 18 8Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M13.73 21C13.5542 21.3031 13.3019 21.5547 12.9982 21.7295C12.6946 21.9044 12.3504 21.9965 12 21.9965C11.6496 21.9965 11.3054 21.9044 11.0018 21.7295C10.6982 21.5547 10.4458 21.3031 10.27 21" stroke="white" stroke-linecap="round" stroke-linejoin="round"></path>
                </svg>
              </a>
              <div class="dropdown-menu dropdown-menu-end">
                <div id="DZ_W_Notification1" class="widget-media dz-scroll p-3" style="height:380px;">
                  <ul class="timeline">
                    <li>
                      <div class="timeline-panel">
                        <div class="media me-2">
                        </div>
                        <div class="media-body">
                          <h6 class="mb-1">Dr sultads Send you Photo</h6>
                          <small class="d-block">29 July 2020 - 02:26 PM</small>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <a class="all-notification" href="javascript:void(0);">See all notifications <i class="ti-arrow-end"></i>
                </a>
              </div>
            </li>
                       
            <li class="nav-item ps-3">
              <div class="dropdown header-profile2">
                <a class="nav-link" href="javascript:void(0);" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <div class="header-info2 d-flex align-items-center">
                    <div class="header-media">
                    </div>
                    <div class="header-info">
                      <h6>{{userInfo?.first_name}} {{userInfo?.last_name}}</h6>                      
                      <p>{{userInfo?.role}}</p>
                    </div>
                  </div>
                </a>
                <div class="dropdown-menu dropdown-menu-end">
                  <div class="card border-0 mb-0">
                    <div class="card-header py-2">
                      <div class="products">
                        <div>
                          <h6>{{userInfo?.first_name}} {{userInfo?.last_name}}</h6>
                          <span>{{userInfo?.email}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="card-body px-0 py-2">
                      <a routerLink="/admin/profile" class="dropdown-item ai-icon ">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9848 15.3462C8.11714 15.3462 4.81429 15.931 4.81429 18.2729C4.81429 20.6148 8.09619 21.2205 11.9848 21.2205C15.8524 21.2205 19.1543 20.6348 19.1543 18.2938C19.1543 15.9529 15.8733 15.3462 11.9848 15.3462Z" stroke="var(--primary)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9848 12.0059C14.5229 12.0059 16.58 9.94779 16.58 7.40969C16.58 4.8716 14.5229 2.81445 11.9848 2.81445C9.44667 2.81445 7.38857 4.8716 7.38857 7.40969C7.38 9.93922 9.42381 11.9973 11.9524 12.0059H11.9848Z" stroke="var(--primary)" stroke-width="1.42857" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        <span class="ms-2">Profile </span>
                      </a>
                      <a routerLink="/admin/change-password" class="dropdown-item ai-icon ">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M16.334 2.75012H7.665C4.644 2.75012 2.75 4.88912 2.75 7.91612V16.0841C2.75 19.1111 4.635 21.2501 7.665 21.2501H16.333C19.364 21.2501 21.25 19.1111 21.25 16.0841V7.91612C21.25 4.88912 19.364 2.75012 16.334 2.75012Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.6889 12.0001C10.6889 13.0231 9.85986 13.8521 8.83686 13.8521C7.81386 13.8521 6.98486 13.0231 6.98486 12.0001C6.98486 10.9771 7.81386 10.1481 8.83686 10.1481H8.83986C9.86086 10.1491 10.6889 10.9781 10.6889 12.0001Z" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M10.6919 12.0001H17.0099V13.8521" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M14.1816 13.8522V12.0002" stroke="#130F26" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        <span class="ms-2">Change Password</span>                        
                      </a>
                      
                      <a (click)="logout()" class="dropdown-item ai-icon c-pointer">
                        <svg class="profle-logout" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ff7979" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                          <polyline points="16 17 21 12 16 7"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        <span class="ms-2 text-danger">Logout </span>
                      </a>
                    </div>

                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  </div>
